import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Actions as ADMIN_ACTIONS } from '../../store/actions/adminActions';
import { Actions as SIDEBARACTIONS } from '../../store/actions/sidebarActions';
import { Link } from 'react-router-dom';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import {
  ChevronDown, X, Search, Building, List, TrendingUp, AreaChart, BarChart, Factory, Users, ShieldCheck,
  BarChart3, Settings, Waves, Plane, PlaneLanding, HelpCircle, Zap, Flag, Hash, BarChart2, TreePine,
  AlignLeft, Building2, Shield, Sofa, Car, Fuel, Wrench, Scale, Trash2, Banknote, Globe, Store,
  ShoppingCart, Network, SlidersHorizontal, PoundSterling, FlaskConical, CreditCard, Percent, Target,
  Download, Upload, ArrowLeftRight, BookOpen, Palette, Newspaper, UserPlus, CircleUser, Link as LinkIcon,
  History, FileInput, Megaphone, ListChecks, Loader2
} from 'lucide-react';

const borderTopStyle = { borderTop: '1px solid var(--sidebar-border, rgba(255,255,255,0.05))' };

const AdminPortalSideBar = ({
  show,
  branding,
  adminView,
  setAdminView,
  cyfAdmin,
  whiteLabelAdmin,
  processingStepFunction,
  getAdminReportsStepFunctionStatus,
  fileProcessing,
  getAdminReports,
  adminSideBarOptions,
  consultantAdmin,
  contractAdmin,
  toggleModal,
}) => {
  const sidebarClass = `nav-collapse ${!show && `hide-left-bar`}`;
  const { sidebarBackground, sidebarLinkColor } = branding.colors || {};
  const [statusIndex, setStatusIndex] = useState(0);
  const [filter, setFilter] = useState(null);

  const execArn = processingStepFunction?.executionArn;

  useEffect(() => {
    if (execArn?.includes('ReportHelper')) {
      const newStatusIndex = statusIndex + 1;
      processingStepFunction &&
        processingStepFunction.executionArn &&
        (!processingStepFunction.status ||
          (processingStepFunction.status !== 'SUCCEEDED' && processingStepFunction.status !== 'FAILED')) &&
        setTimeout(async () => {
          await getAdminReportsStepFunctionStatus(processingStepFunction.executionArn);
          setStatusIndex(newStatusIndex);
        }, 1500);
    }
  }, [execArn, statusIndex, processingStepFunction, getAdminReportsStepFunctionStatus]);

  return (
    <aside>
      <div id='sidebar' className={sidebarClass}>
        <div className='leftside-navigation'>
          <ul className='sidebar-menu admin-view' id='nav-accordion' style={{ backgroundColor: sidebarBackground }}>
            <div className='md:mb-12'>
              {Object.keys(adminSideBarOptions)
                .filter((o) => {
                  // CYF admin first — local dev toggle sets cyfAdmin + CYF_ADMIN portal perm
                  if (cyfAdmin && !contractAdmin) {
                    return (
                      !adminSideBarOptions[o]?.exclusiveFor ||
                      adminSideBarOptions[o]?.exclusiveFor?.includes(cyfAdmin)
                    );
                  }
                  if (whiteLabelAdmin) return adminSideBarOptions[o]?.exclusiveFor?.includes(whiteLabelAdmin);
                  if (consultantAdmin) return adminSideBarOptions[o]?.exclusiveFor?.includes(consultantAdmin);
                  return (
                    !adminSideBarOptions[o]?.exclusiveFor ||
                    adminSideBarOptions[o]?.exclusiveFor.includes(cyfAdmin) ||
                    adminSideBarOptions[o]?.exclusiveFor.includes(contractAdmin)
                  );
                })
                .map((key, index) => {
                  const type = adminSideBarOptions[key]?.type;
                  return (
                    <li style={borderTopStyle} key={index} id={adminSideBarOptions[key]?.title}>
                      {type === 'accordion' && (
                        <Collapsible className='sidebar-accordion'>
                          <CollapsibleTrigger
                            className='sidebar-label list flex w-full min-w-0 list-none items-center justify-between gap-2 py-2 pr-2 [&[data-state=open]>svg]:rotate-180'
                            style={{ '--sidebar-accordion-label-color': sidebarLinkColor }}>
                            <span className='flex min-w-0 flex-1 items-center gap-2 truncate'>
                              {adminSideBarOptions[key]?.icon}
                              <span className='truncate' style={{ marginLeft: 8 }}>{adminSideBarOptions[key]?.title}</span>
                            </span>
                            <ChevronDown
                              size={14}
                              strokeWidth={1.5}
                              className='shrink-0 transition-transform'
                              style={{ '--sidebar-accordion-icon-color': sidebarLinkColor }}
                              aria-hidden
                            />
                          </CollapsibleTrigger>
                          <CollapsibleContent className='pl-6'>
                            {key === 'dataTeamTables' && (
                              <div className='flex items-center justify-center mb-2'>
                                <input
                                  type='text'
                                  placeholder='Search...'
                                  onChange={(e) => setFilter(e.target.value || null)}
                                  value={filter || ''}
                                  className='rounded-sm p-1.5'
                                />
                                {filter ? (
                                  <X
                                    size={18}
                                    strokeWidth={1.5}
                                    className='ml-2'
                                    style={{ color: sidebarLinkColor, cursor: 'pointer' }}
                                    onClick={() => setFilter(null)}
                                  />
                                ) : (
                                  <Search size={17} strokeWidth={1.5} className='ml-2' style={{ color: sidebarLinkColor }} />
                                )}
                              </div>
                            )}
                            {adminSideBarOptions[key]?.options
                              .filter(
                                (opt) =>
                                  opt?.exclusiveFor?.includes(cyfAdmin) ||
                                  opt?.exclusiveFor?.includes(whiteLabelAdmin) ||
                                  !opt?.exclusiveFor,
                              )
                              ?.filter((option) => {
                                if (key === 'dataTeamTables') {
                                  if (filter) {
                                    return (
                                      option.name.toLowerCase().includes(filter?.toLowerCase()) ||
                                      option?.options?.some((opt) => opt.name.toLowerCase().includes(filter?.toLowerCase()))
                                    );
                                  } else {
                                    return true;
                                  }
                                } else {
                                  return true;
                                }
                              })
                              .map((option, optionIndex) => {
                                if (key === 'downloads') {
                                  if (option.type === 'link') {
                                    return (
                                      <Link
                                        key={optionIndex}
                                        id={option.id}
                                        to=''
                                        className='flex items-center gap-2 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5 [&.active]:text-sidebar-primary [&.active]:border-l-sidebar-primary [&.active]:bg-sidebar-accent'
                                        onClick={() =>
                                          !fileProcessing?.[option.flag] && getAdminReports(option.flag, option.flag)
                                        }>
                                        {fileProcessing?.[option.flag] ? (
                                          <Loader2 size={16} strokeWidth={1.5} className='animate-spin shrink-0' style={{ paddingLeft: 10 }} />
                                        ) : option.flag === 'activity' ? (
                                          <BarChart3 size={16} strokeWidth={1.5} className='shrink-0' />
                                        ) : option.flag === 'entity' ? (
                                          <TreePine size={16} strokeWidth={1.5} className='shrink-0' />
                                        ) : option.flag === 'conversionFactors' ? (
                                          <Settings size={16} strokeWidth={1.5} className='shrink-0' />
                                        ) : option.flag === 'usageTypes' ? (
                                          <ShieldCheck size={16} strokeWidth={1.5} className='shrink-0' />
                                        ) : (
                                          <BarChart2 size={16} strokeWidth={1.5} className='shrink-0' />
                                        )}
                                        <span>{option.name}</span>
                                      </Link>
                                    );
                                  } else {
                                    return (
                                      <Collapsible className='sidebar-accordion pl-2' key={optionIndex}>
                                        <CollapsibleTrigger
                                          className='sidebar-label list flex w-full min-w-0 list-none items-center justify-between gap-2 py-2 pr-2 [&[data-state=open]>svg]:rotate-180'
                                          style={{ '--sidebar-accordion-label-color': sidebarLinkColor }}>
                                          <span className='flex min-w-0 flex-1 items-center gap-2 truncate'>
                                            {option.icon}
                                            <span className='truncate' style={{ marginLeft: 8 }}>{option.title}</span>
                                          </span>
                                          <ChevronDown
                                            size={14}
                                            strokeWidth={1.5}
                                            className='shrink-0 transition-transform'
                                            style={{ '--sidebar-accordion-icon-color': sidebarLinkColor }}
                                            aria-hidden
                                          />
                                        </CollapsibleTrigger>
                                        <CollapsibleContent className='pl-4'>
                                          {option?.options.map((opt, mailtoIndex) => (
                                            <a
                                              key={mailtoIndex}
                                              className='flex items-center gap-2 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5'
                                              href={opt?.href}
                                              target='_blank'>
                                              {opt?.icon}
                                              <span>{opt?.name}</span>
                                            </a>
                                          ))}
                                        </CollapsibleContent>
                                      </Collapsible>
                                    );
                                  }
                                } else if (key === 'dataTeamTables') {
                                  const matchesFilter = filter
                                    ? option.name.toLowerCase().includes(filter.toLowerCase()) ||
                                      option?.options?.some((nestedOption) =>
                                        nestedOption.name.toLowerCase().includes(filter.toLowerCase()),
                                      )
                                    : true;

                                  // If the option or its nested options match, render it
                                  if (matchesFilter) {
                                    if (option.type === 'accordion') {
                                      // Filter nested options based on the search term
                                      const filteredNestedOptions = !filter
                                        ? option?.options // If filter is empty, return all options
                                        : option?.options?.filter((nestedOption) =>
                                            nestedOption.name.toLowerCase().includes(filter.toLowerCase()),
                                          );

                                      return (
                                        <Collapsible
                                          className='sidebar-accordion pl-2'
                                          key={optionIndex}
                                          defaultOpen={!!filter}>
                                          <CollapsibleTrigger
                                            className='sidebar-label list flex w-full min-w-0 list-none items-center justify-between gap-2 py-2 pr-2 [&[data-state=open]>svg]:rotate-180'
                                            style={{ '--sidebar-accordion-label-color': sidebarLinkColor }}>
                                            <span className='flex min-w-0 flex-1 items-center gap-2 truncate'>
                                              {option.icon}
                                              <span className='truncate' style={{ marginLeft: 8 }}>{option.name}</span>
                                            </span>
                                            <ChevronDown
                                              size={14}
                                              strokeWidth={1.5}
                                              className='shrink-0 transition-transform'
                                              style={{ '--sidebar-accordion-icon-color': sidebarLinkColor }}
                                              aria-hidden
                                            />
                                          </CollapsibleTrigger>
                                          <CollapsibleContent className='pl-4'>
                                            {filteredNestedOptions?.map((nestedOption, nestedIndex) => (
                                              <Link to={nestedOption.to} key={nestedIndex} id={nestedOption.id} className='flex items-center gap-2 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5 [&.active]:text-sidebar-primary [&.active]:border-l-sidebar-primary [&.active]:bg-sidebar-accent'>
                                                {nestedOption.icon}
                                                <span>{nestedOption.name}</span>
                                              </Link>
                                            ))}
                                          </CollapsibleContent>
                                        </Collapsible>
                                      );
                                    } else {
                                      // Render non-accordion options
                                      return (
                                        <Link
                                          to={option.to}
                                          key={optionIndex}
                                          id={option.id}
                                          className='flex items-center gap-2 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5 [&.active]:text-sidebar-primary [&.active]:border-l-sidebar-primary [&.active]:bg-sidebar-accent'
                                          onClick={() => {
                                            if (option.flag === 'linkStripeAccount') {
                                              toggleModal(true, 'linkStripeAccount');
                                            }
                                          }}>
                                          {option.icon}
                                          <span>{option.name}</span>
                                        </Link>
                                      );
                                    }
                                  }
                                  return null;
                                } else if (key === 'uploads') {
                                  return (
                                    <Link
                                      key={optionIndex}
                                      to=''
                                      id={option.id}
                                      className='flex items-center gap-2 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5 [&.active]:text-sidebar-primary [&.active]:border-l-sidebar-primary [&.active]:bg-sidebar-accent'
                                      onClick={() => {
                                        if (option.flag === 'deleteOrgs') {
                                          toggleModal(true, 'deleteOrgs');
                                        } else if (option.flag === 'importMixedTemplates') {
                                          toggleModal(true, 'importMixedTemplates');
                                        }
                                      }}>
                                      {option.icon}
                                      <span>{option.name}</span>
                                    </Link>
                                  );
                                } else if (option.type === 'accordion') {
                                  return (
                                    <Collapsible className='sidebar-accordion pl-2' key={optionIndex}>
                                      <CollapsibleTrigger
                                        className='sidebar-label list flex w-full min-w-0 list-none items-center justify-between gap-2 py-2 pr-2 [&[data-state=open]>svg]:rotate-180'
                                        style={{ '--sidebar-accordion-label-color': sidebarLinkColor }}>
                                        <span className='flex min-w-0 flex-1 items-center gap-2 truncate'>
                                          {option.icon}
                                          <span className='truncate' style={{ marginLeft: 8 }}>{option.name}</span>
                                        </span>
                                        <ChevronDown
                                          size={14}
                                          strokeWidth={1.5}
                                          className='shrink-0 transition-transform'
                                          style={{ '--sidebar-accordion-icon-color': sidebarLinkColor }}
                                          aria-hidden
                                        />
                                      </CollapsibleTrigger>
                                      <CollapsibleContent className='pl-4'>
                                        {option?.options.map((opt, accordionIndex) => (
                                          <Link to={opt.to} key={accordionIndex} id={opt.id} className='flex items-center gap-2 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5 [&.active]:text-sidebar-primary [&.active]:border-l-sidebar-primary [&.active]:bg-sidebar-accent'>
                                            {opt.icon}
                                            <span>{opt.name}</span>
                                          </Link>
                                        ))}
                                      </CollapsibleContent>
                                    </Collapsible>
                                  );
                                } else {
                                  return (
                                    <Link
                                      to={option.to}
                                      key={optionIndex}
                                      id={option.id}
                                      className='flex items-center gap-2 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5 [&.active]:text-sidebar-primary [&.active]:border-l-sidebar-primary [&.active]:bg-sidebar-accent'
                                      onClick={() => {
                                        if (option.flag === 'linkStripeAccount') {
                                          toggleModal(true, 'linkStripeAccount');
                                        }
                                      }}>
                                      {option.icon}
                                      <span>{option.name}</span>
                                    </Link>
                                  );
                                }
                              })}
                          </CollapsibleContent>
                        </Collapsible>
                      )}
                      {type === 'link' && (
                        <Link
                          id={adminSideBarOptions[key]?.id}
                          to={adminSideBarOptions[key]?.to}
                          className='flex items-center gap-2.5 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5 [&.active]:text-sidebar-primary [&.active]:border-l-sidebar-primary [&.active]:bg-sidebar-accent'>
                          {adminSideBarOptions[key]?.icon}
                          <span>{adminSideBarOptions[key]?.title}</span>
                        </Link>
                      )}
                      {type === 'mailto' && (
                        <a
                          className='flex items-center gap-2.5 py-2 px-6 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent transition-all duration-200 hover:text-sidebar-foreground hover:bg-white/5'
                          href={adminSideBarOptions[key].href}
                          target='_blank'>
                          {adminSideBarOptions[key].icon}
                          <span>{adminSideBarOptions[key].title}</span>
                        </a>
                      )}
                    </li>
                  );
                })}
            </div>
            <div>
              <li
                style={{
                  borderTop: '1px solid var(--sidebar-border, rgba(255,255,255,0.05))',
                  backgroundColor: sidebarBackground,
                }}
                className='admin-portal-toggle'>
                <Label
                  htmlFor='admin-portal-sidebar-switch'
                  className='sidebar-toggle sidebar-label flex cursor-pointer items-center gap-2'
                  style={{ '--sidebar-toggle-color': sidebarLinkColor }}>
                  <Switch
                    id='admin-portal-sidebar-switch'
                    className='data-[state=checked]:bg-primary data-[state=unchecked]:bg-white/30 [&>span]:bg-white'
                    checked={adminView}
                    onCheckedChange={() => setAdminView(!adminView)}
                  />
                  Admin Portal
                </Label>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </aside>
  );
};

const mapStateToProps = (state) => {
  const { cyfAdmin, whiteLabelAdmin, consultantAdmin, permissions } = state.profile?.details || {};
  const adminSideBarOptions = {};
  adminSideBarOptions.organsations = {
    title: 'Organisations',
    type: 'accordion',
    icon: <Building size={16} strokeWidth={1.5} />,
    exclusiveFor: ['WHITELABEL', 'CYF_ADMIN', 'CONSULTANT'],
    options: [
      {
        type: 'link',
        name: 'List',
        to: '/admin/organisations',
        icon: <List size={16} strokeWidth={1.5} />,
      },
      {
        type: 'link',
        name: 'Metrics',
        to: '/admin/organisationMetrics',
        icon: <TrendingUp size={16} strokeWidth={1.5} />,
        exclusiveFor: ['CYF_ADMIN'],
      },
    ],
  };
  adminSideBarOptions.dataTeamTables = {
    title: 'Data Team',
    type: 'accordion',
    icon: <AreaChart size={16} strokeWidth={1.5} />,
    exclusiveFor: ['CYF_ADMIN'],
    options: [
      {
        type: 'link',
        name: 'Usage Data',
        to: '/admin/usageData',
        icon: <BarChart size={16} strokeWidth={1.5} />,
      },
      {
        type: 'link',
        name: 'Industries',
        to: '/admin/industries',
        icon: <Factory size={16} strokeWidth={1.5} />,
      },
      {
        type: 'link',
        name: 'Industry Sub-Categories',
        to: '/admin/industrySubcategory',
        icon: <Factory size={16} strokeWidth={1.5} />,
      },
      { type: 'link', name: 'Users', to: '/admin/profiles', icon: <Users size={16} strokeWidth={1.5} /> },
      {
        type: 'link',
        name: 'User Permissions',
        to: '/admin/userPermissions',
        icon: <ShieldCheck size={16} strokeWidth={1.5} />,
      },
      {
        type: 'link',
        name: 'Reports',
        to: '/admin/reports',
        icon: <BarChart3 size={16} strokeWidth={1.5} />,
      },
      {
        id: 'ConversionFactors',
        type: 'link',
        name: 'Conversion Factors',
        to: '/admin/conversionfactors',
        icon: <Settings size={16} strokeWidth={1.5} />,
      },
      {
        id: 'SecrFuelConversions',
        type: 'link',
        name: 'SECR Conversions',
        to: '/admin/secrFuelConversions',
        icon: <Fuel size={16} strokeWidth={1.5} />,
      },
      {
        type: 'link',
        name: 'Sea Distances',
        to: '/admin/seaDistances',
        icon: <Waves size={16} strokeWidth={1.5} />,
      },
      {
        id: 'SeaDistances',
        type: 'link',
        name: 'Sea Distances',
        to: '/admin/seaDistances',
        icon: <Waves size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Airports',
        type: 'link',
        name: 'Airports',
        to: '/admin/airports',
        icon: <Plane size={16} strokeWidth={1.5} />,
      },
      {
        id: 'ClosestAirport',
        type: 'link',
        name: 'Closest Airport',
        to: '/admin/closestAirport',
        icon: <PlaneLanding size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Help',
        type: 'link',
        name: 'Help',
        to: '/admin/help',
        icon: <HelpCircle size={16} strokeWidth={1.5} />,
      },
      {
        id: 'ElectricitySources',
        name: 'Electricity Sources',
        type: 'link',
        to: '/admin/electricitySources',
        icon: <Zap size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Countries',
        name: 'Countries',
        type: 'link',
        to: '/admin/countries',
        icon: <Flag size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Scope3Categories',
        name: 'Scope 3 Categories',
        type: 'link',
        to: '/admin/scope3Categories',
        icon: <Hash size={16} strokeWidth={1.5} />,
      },
      {
        id: 'MarketFactors',
        name: 'Market Factors',
        type: 'link',
        to: '/admin/marketFactors',
        icon: <BarChart2 size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Entities',
        name: 'Entities',
        type: 'link',
        to: '/admin/entities',
        icon: <TreePine size={16} strokeWidth={1.5} />,
      },
      {
        id: 'SubEntities',
        name: 'Sub Entities',
        type: 'link',
        to: '/admin/subEntities',
        icon: <TreePine size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Benchmark',
        name: 'Benchmark',
        type: 'link',
        to: '/admin/benchmark',
        icon: <AlignLeft size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Facilities',
        name: 'Facilities',
        type: 'accordion',
        icon: <Building2 size={16} strokeWidth={1.5} />,
        options: [
          {
            id: 'Facilities_List',
            type: 'link',
            name: 'List',
            to: '/admin/facilities',
            icon: <List size={16} strokeWidth={1.5} />,
          },
          {
            id: 'Facilities_Types',
            type: 'link',
            name: 'Types',
            to: '/admin/facilitiesType',
            icon: <Users size={16} strokeWidth={1.5} />,
          },
        ],
      },
      {
        id: 'UsageTypes',
        name: 'Usage Types',
        type: 'accordion',
        icon: <Shield size={16} strokeWidth={1.5} />,
        options: [
          {
            id: 'SeatType',
            type: 'link',
            name: 'Seat',
            to: '/admin/seatType',
            icon: <Sofa size={16} strokeWidth={1.5} />,
          },
          {
            id: 'VehicleType',
            type: 'link',
            name: 'Vehicle',
            to: '/admin/vehicleType',
            icon: <Car size={16} strokeWidth={1.5} />,
          },
          {
            type: 'link',
            name: 'Fuel',
            to: '/admin/fuelType',
            icon: <Fuel size={16} strokeWidth={1.5} />,
          },
          {
            id: 'FuelType',
            type: 'link',
            name: 'Fuel',
            to: '/admin/fuelType',
            icon: <Fuel size={16} strokeWidth={1.5} />,
          },
          {
            id: 'ProductionType',
            type: 'link',
            name: 'Production',
            to: '/admin/productionType',
            icon: <Wrench size={16} strokeWidth={1.5} />,
          },
          {
            type: 'link',
            name: 'Load',
            to: '/admin/loadType',
            icon: <Scale size={16} strokeWidth={1.5} />,
          },
          {
            type: 'link',
            name: 'Waste',
            to: '/admin/wasteType',
            icon: <Trash2 size={16} strokeWidth={1.5} />,
          },
          {
            type: 'link',
            name: 'Price',
            to: '/admin/priceType',
            icon: <Banknote size={16} strokeWidth={1.5} />,
          },
          {
            id: 'LoadType',
            type: 'link',
            name: 'Load',
            to: '/admin/loadType',
            icon: <Scale size={16} strokeWidth={1.5} />,
          },
          {
            id: 'WasteType',
            type: 'link',
            name: 'Waste',
            to: '/admin/wasteType',
            icon: <Trash2 size={16} strokeWidth={1.5} />,
          },
          {
            id: 'PriceType',
            type: 'link',
            name: 'Price',
            to: '/admin/priceType',
            icon: <Banknote size={16} strokeWidth={1.5} />,
          },
          {
            id: 'OriginLocation',
            type: 'link',
            name: 'Origin Location',
            to: '/admin/originlocation',
            icon: <Globe size={16} strokeWidth={1.5} />,
          },
          {
            id: 'FinalLocation',
            type: 'link',
            name: 'Final Location',
            to: '/admin/finallocation',
            icon: <Globe size={16} strokeWidth={1.5} />,
          },
          {
            id: 'FactorProvider',
            type: 'link',
            name: 'Factor Provider',
            to: '/admin/factorprovider',
            icon: <Store size={16} strokeWidth={1.5} />,
          },
          {
            type: 'link',
            name: 'Metric',
            to: '/admin/metrics',
            icon: <TrendingUp size={16} strokeWidth={1.5} />,
          },
        ],
      },
      {
        id: 'AddOns',
        name: 'Add Ons',
        type: 'link',
        to: '/admin/addOns',
        icon: <ShoppingCart size={16} strokeWidth={1.5} />,
      },
      {
        id: 'AddOnProducts',
        name: 'Add-On Products',
        type: 'link',
        to: '/admin/addOnProducts',
        icon: <ShoppingCart size={16} strokeWidth={1.5} />,
      },
      {
        id: 'UsageTypeDetails',
        name: 'Usage Type Details',
        type: 'link',
        to: '/admin/usageTypeDetails',
        icon: <Shield size={16} strokeWidth={1.5} />,
      },
      {
        id: 'OrganisationHierarchy',
        name: 'Organisation Hierarchy',
        type: 'link',
        to: '/admin/organisationHierarchy',
        icon: <Network size={16} strokeWidth={1.5} />,
      },
      {
        id: 'IntegrationMappings',
        name: 'Integration Mappings',
        type: 'link',
        to: '/admin/integrationMappings',
        icon: <SlidersHorizontal size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Currencies',
        name: 'Currencies',
        type: 'link',
        to: '/admin/currencies',
        icon: <PoundSterling size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Features',
        name: 'Features',
        type: 'link',
        to: '/admin/features',
        icon: <FlaskConical size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Stripe',
        name: 'Stripe',
        type: 'link',
        to: '/admin/stripe',
        icon: <CreditCard size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Currency-Rates',
        name: 'Currency Rates',
        type: 'link',
        to: '/admin/currency-rates',
        icon: <Percent size={16} strokeWidth={1.5} />,
      },
      {
        name: 'Factor Source',
        type: 'link',
        to: '/admin/factorSource',
        icon: <Globe size={16} strokeWidth={1.5} />,
      },
      {
        name: 'SBT Targets',
        type: 'link',
        to: '/admin/orgTargets',
        icon: <Target size={16} strokeWidth={1.5} />,
      },
    ],
  };
  adminSideBarOptions.downloads = {
    title: 'Downloads',
    type: 'accordion',
    icon: <Download size={16} strokeWidth={1.5} />,
    exclusiveFor: ['WHITELABEL', 'CYF_ADMIN', 'CONSULTANT'],
    options: [
      {
        id: 'Activity-Report',
        type: 'link',
        name: 'Activity Report',
        to: 'zz',
        icon: <Sofa size={16} strokeWidth={1.5} />,
        flag: 'activity',
      },
      {
        id: 'Entities-Subentities',
        type: 'link',
        name: 'Entities & Subentities',
        to: 'zz',
        icon: <TreePine size={16} strokeWidth={1.5} />,
        flag: 'entity',
        exclusiveFor: ['CYF_ADMIN'],
      },
      {
        id: 'Conversion-Factors',
        type: 'link',
        name: 'Conversion Factors',
        to: 'zz',
        icon: <Settings size={16} strokeWidth={1.5} />,
        flag: 'conversionFactors',
        exclusiveFor: ['CYF_ADMIN'],
      },
      {
        id: 'Market-Factors',
        type: 'link',
        name: 'Market Factors',
        to: 'zz',
        icon: <BarChart2 size={16} strokeWidth={1.5} />,
        flag: 'marketFactors',
        exclusiveFor: ['CYF_ADMIN'],
      },
      {
        type: 'link',
        name: 'Usage Types',
        to: 'zz',
        icon: <ShieldCheck size={16} strokeWidth={1.5} />,
        flag: 'usageTypes',
        exclusiveFor: ['CYF_ADMIN'],
      },
      {
        id: 'White-Labels',
        title: 'White Labels',
        type: 'accordion',
        icon: <BookOpen size={16} strokeWidth={1.5} />,
        exclusiveFor: ['CYF_ADMIN'],
        options: [
          {
            id: 'WhiteLabel-PDF',
            type: 'mailto',
            name: 'White Label Colours PDF',
            href: 'https://s3.eu-west-2.amazonaws.com/downloads.compareyourfootprint.com/White_Label_Resources/Whitelabel.Colors.pdf',
            icon: <Palette size={16} strokeWidth={1.5} />,
            exclusiveFor: ['CYF_ADMIN'],
          },
          {
            id: 'WhiteLabel-Form',
            type: 'mailto',
            name: 'White Label Form',
            href: 'https://s3.eu-west-2.amazonaws.com/downloads.compareyourfootprint.com/White_Label_Resources/WhiteLabelForm.xlsx',
            icon: <Newspaper size={16} strokeWidth={1.5} />,
            exclusiveFor: ['CYF_ADMIN'],
          },
        ],
      },
    ],
  };
  adminSideBarOptions.uploads = {
    title: 'Uploads',
    type: 'accordion',
    exclusiveFor: ['CYF_ADMIN'],
    icon: <Upload size={16} strokeWidth={1.5} />,
    options: [
      {
        id: 'DeleteOrganisations',
        type: 'link',
        name: 'Delete Organisations',
        to: 'zz',
        icon: <Trash2 size={16} strokeWidth={1.5} />,
        flag: 'deleteOrgs',
      },
      {
        id: 'Import-Mixed-Template',
        type: 'link',
        name: 'Import Mixed Template',
        to: 'zz',
        icon: <Download size={16} strokeWidth={1.5} />,
        flag: 'importMixedTemplates',
      },
    ],
  };
  adminSideBarOptions.transferPortal = {
    id: 'TransferPortal',
    title: 'Transfer Portal',
    type: 'link',
    to: '/admin/transferPortal',
    exclusiveFor: ['CYF_ADMIN'],
    icon: <ArrowLeftRight size={16} strokeWidth={1.5} />,
  };
  adminSideBarOptions.whiteLabelResources = {
    id: 'WhiteLabelResources',
    title: 'White Label Resources',
    type: 'mailto',
    href: 'https://www.compareyourfootprint.com/partners/white-label/training-hub/',
    icon: <BookOpen size={16} strokeWidth={1.5} />,
    exclusiveFor: ['WHITELABEL', 'CYF_ADMIN'],
  };
  adminSideBarOptions.salesPortal = {
    id: 'SalesPortal',
    title: 'Sales Portal',
    type: 'accordion',
    icon: <TrendingUp size={16} strokeWidth={1.5} />,
    // Match App.js agreement routes: `(CONTRACT || cyfAdmin)`.
    exclusiveFor: ['CONTRACT', 'CYF_ADMIN'],
    exclusiveFor: ['CONTRACT', 'CYF_ADMIN'],
    options: [
      {
        id: 'NewAgreement',
        type: 'link',
        name: 'New agreement',
        to: '/admin/agreements/new',
        icon: <UserPlus size={16} strokeWidth={1.5} />,
      },
      {
        id: 'AgreementsList',
        type: 'link',
        name: 'Agreements',
        to: '/admin/agreements',
        icon: <CircleUser size={16} strokeWidth={1.5} />,
      },
      {
        id: 'IndexationRates',
        type: 'link',
        name: 'Indexation rates',
        to: '/admin/indexation/rates',
        icon: <Percent size={16} strokeWidth={1.5} />,
      },
      {
        id: 'PricingBands',
        type: 'link',
        name: 'Pricing Bands',
        to: '/admin/sales/pricingBands',
        icon: <PoundSterling size={16} strokeWidth={1.5} />,
      },
      {
        id: 'Link-Stripe-Account',
        type: 'link',
        name: 'Un/Link Stripe Account To Organisation',
        to: '',
        icon: <LinkIcon size={16} strokeWidth={1.5} />,
        flag: 'linkStripeAccount',
      },
    ],
  };
  adminSideBarOptions.auditLogs = {
    title: 'Audit Logs',
    type: 'link',
    to: '/admin/auditLogs',
    icon: <History size={16} strokeWidth={1.5} />,
    exclusiveFor: ['CYF_ADMIN'],
  };
  adminSideBarOptions.templateVersioning = {
    title: 'Template Versioning',
    type: 'link',
    to: '/admin/templates',
    icon: <FileInput size={16} strokeWidth={1.5} />,
    exclusiveFor: ['CYF_ADMIN'],
  };
  adminSideBarOptions.announcements = {
    title: 'Announcements',
    type: 'link',
    to: '/admin/announcement',
    icon: <Megaphone size={16} strokeWidth={1.5} />,
    exclusiveFor: ['WHITELABEL', 'CYF_ADMIN'],
  };
  adminSideBarOptions.theming = {
    title: 'Theming',
    type: 'link',
    to: '/admin/theming',
    icon: <Palette size={16} strokeWidth={1.5} />,
    exclusiveFor: ['WHITELABEL', 'CYF_ADMIN'],
  };
  adminSideBarOptions.reportTemplates = {
    title: 'Report Templates',
    type: 'link',
    to: '/admin/reportTemplates',
    icon: <ListChecks size={16} strokeWidth={1.5} />,
    exclusiveFor: ['CYF_ADMIN'],
  };
  adminSideBarOptions.settings = {
    id: 'Settings',
    title: 'Settings',
    type: 'link',
    to: '/admin/settings',
    icon: <Settings size={16} strokeWidth={1.5} />,
    exclusiveFor: ['WHITELABEL', 'CYF_ADMIN'],
  };

  return {
    processingStepFunction: state.processingImport?.status?.data || state.processingImport?.status,
    fileProcessing: state?.admin?.export?.downloading,
    show: state.sidebar.show,
    branding: state.branding,
    cyfAdmin:
      (cyfAdmin && permissions?.portal?.includes('CYF_ADMIN') && 'CYF_ADMIN') ||
      (state.isLocalDevelopment && cyfAdmin && 'CYF_ADMIN'),
    whiteLabelAdmin: whiteLabelAdmin && permissions?.portal?.includes('WHITELABEL') && 'WHITELABEL',
    consultantAdmin: consultantAdmin && permissions?.portal?.includes('CONSULTANT') && 'CONSULTANT',
    contractAdmin: permissions?.portal?.includes('CONTRACT') && 'CONTRACT',
    adminSideBarOptions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleSidebar: () => dispatch(SIDEBARACTIONS.toggleSidebar()),
  toggleModal: (status, action) => dispatch(ADMIN_ACTIONS.toggleModal(status, action)),
  getAdminReports: (tableName, fileType) => dispatch(ADMIN_ACTIONS.getAdminReports(tableName, fileType)),
  getAdminReportsStepFunctionStatus: (importArn) => dispatch(ADMIN_ACTIONS.getAdminReportsStepFunctionStatus(importArn)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminPortalSideBar);
